import React from 'react';
import Typography from '@material-ui/core/Typography';
import styles from './styles';
import { Container } from '~/components/ui';

export const PrivacyPolicyPage = () => {
    const classes = styles();
    return (
        <Container className={classes.mainContainer}>
            <section>
                <Typography className={classes.title} variant="h3">
                    Privacy
                </Typography>
                <Typography variant="body1" className={classes.text}>
                    This privacy policy applies to the website orthosnap.com
                    (“Orthosnap”) where this privacy policy is posted, to
                    subdomains of the website, to any browser extensions and
                    application add-ins providing the Orthosnap service, and to
                    the Orthosnap mobile application (collectively, the “Site”).
                    This privacy policy does not apply to information that is
                    collected offline or to any information that may be posted
                    on the Site by third parties. At Orthosnap (“We” or “Us”),
                    we are committed to protecting your privacy. We firmly
                    believe that electronic security and privacy are necessary
                    for the continued success of the Internet. In support of
                    this, we only use the personally identifiable information
                    (“personal information” or “personal data”) that you provide
                    in accordance with the terms outlined below.
                </Typography>
                <Typography variant="body1" className={classes.text}>
                    This Privacy Policy covers any personal information we
                    obtain when you visit us, use our services, or access the
                    features on the websites that Orthosnap owns or controls
                    (today or in the future), including
                    https://www.orthosnap.com/ (the “Sites”). You can access the
                    Sites in many ways, including from a computer or mobile
                    phone, and this Privacy Policy will apply regardless of the
                    means of access. This Privacy Policy also governs the use of
                    personal information we obtain from you from any third party
                    site or application where we post content or invite your
                    feedback or participation, including, but not limited to,
                    Twitter, Facebook, LinkedIn, Instagram, YouTube, Pinterest,
                    and Google+ (“Third Party Sites”). Orthosnap cannot control
                    the privacy policies or practices of Third Party Sites or of
                    companies Orthosnap does not own or control, and cannot
                    control the actions of people Orthosnap does not employ or
                    manage. You should always check the privacy policies of
                    Third Party Sites and your privacy settings.
                </Typography>
                <Typography variant="body1" className={classes.text}>
                    BY USING THE SITE, YOU CONSENT TO THE TERMS AND CONDITIONS
                    OF THIS PRIVACY POLICY AND TO OUR PROCESSING OF PERSONAL
                    INFORMATION FOR THE PURPOSES STATED BELOW. IF YOU DO NOT
                    AGREE TO THE TERMS AND CONDITIONS OF THIS PRIVACY POLICY,
                    PLEASE DO NOT USE THE SITE.
                </Typography>
            </section>
            <section className={classes.section}>
                <Typography className={classes.title} variant="h4">
                    A. Information Collected
                </Typography>
                <Typography variant="body1" className={classes.text}>
                    We collect two types of information from visitors to the
                    Site: (1) Personally Identifiable Information; and (2)
                    Non-Personally Identifiable Information, such as your IP
                    address or cookies.
                </Typography>
                <Typography variant="body1" className={classes.text}>
                    For users who optionally elect to connect to their email and
                    calendars service, we will also use Contacts Information to
                    assist our service send to recipients.
                </Typography>
            </section>
            <section className={classes.section}>
                <Typography className={classes.text} variant="h5">
                    (1) Personally Identifiable Information
                </Typography>
                <Typography variant="body1" className={classes.text}>
                    Personally Identifiable Information” is information that
                    identifies you personally, such as your name, address,
                    telephone number, email address, or employer name. Orthosnap
                    collects and stores the personally identifiable information
                    that you have provided to us. Here are some examples of ways
                    in which we may collect your personally identifiable
                    information on the Site:
                </Typography>
                <ul className={classes.list}>
                    <li>
                        <Typography
                            variant="body1"
                            className={classes.listItem}
                        >
                            We collect your first and last name, email address
                            and phone number when you create an account with us;
                        </Typography>
                    </li>
                    <li>
                        <Typography
                            variant="body1"
                            className={classes.listItem}
                        >
                            We may tie your personally identifiable information
                            to your non-personally identifiable information,
                            described below, in an effort to track your usage of
                            our services so that we can deliver services to you
                            that meet your needs; and
                        </Typography>
                    </li>
                    <li>
                        <Typography
                            variant="body1"
                            className={classes.listItem}
                        >
                            We may collect your name, email address or phone
                            number if you contact us with a question or comment:
                        </Typography>
                    </li>
                </ul>
                <Typography variant="body1" className={classes.text}>
                    The above list provides an example of the personally
                    identifiable information that may be collected on the Site.
                    If you do not want Orthosnap to collect your personally
                    identifiable information, please do not create an account
                    with us.
                </Typography>
            </section>
            <section className={classes.section}>
                <Typography className={classes.text} variant="h5">
                    (2) Non-Personally Identifiable Information
                </Typography>
                <Typography variant="body1" className={classes.text}>
                    “Non-Personally Identifiable Information” can be technical
                    information or it can be demographic information, such as
                    your age, location, gender or job description, as well as
                    information about your employer. Non-personally identifiable
                    information does NOT identify you personally. Here are some
                    examples of the non-personally identifiable information that
                    is collected via the Site:
                </Typography>
                <ul className={classes.list}>
                    <li>
                        <Typography
                            variant="body1"
                            className={classes.listItem}
                        >
                            Internet Protocol (IP) address — Your IP address is
                            a number that lets computers attached to the
                            Internet know where to send you data.
                        </Typography>
                    </li>
                    <li>
                        <Typography
                            variant="body1"
                            className={classes.listItem}
                        >
                            Cookie — A “cookie” is a small text file that may be
                            used to collect information about your activity on
                            the Site.
                        </Typography>
                    </li>
                </ul>
                <Typography variant="body1" className={classes.text}>
                    We collect the above non-personally identifiable information
                    from all visitors to our Site. If you do not want Orthosnap
                    to have access to this information, please do not visit our
                    Site.
                </Typography>
            </section>
            <section className={classes.section}>
                <Typography className={classes.text} variant="h5">
                    (3) (Optional) Case information
                </Typography>
                <Typography variant="body1" className={classes.text}>
                    “Case Information” is information that identifies your
                    potential cases and may include information such as name,
                    address, telephone number, email address, and interactions
                    such as Rx forms and chief complaints. Here are some
                    examples of ways in which we may collect your Case
                    Information on the Site:
                </Typography>
                <ul className={classes.list}>
                    <li>
                        <Typography
                            variant="body1"
                            className={classes.listItem}
                        >
                            When you submit a case to us using our Site,
                            Application, or Mobile client.
                        </Typography>
                    </li>
                    <li>
                        <Typography
                            variant="body1"
                            className={classes.listItem}
                        >
                            When you email us information about a case with a
                            request to create for you on our Site
                        </Typography>
                    </li>
                    <li>
                        <Typography
                            variant="body1"
                            className={classes.listItem}
                        >
                            When you text or call us and provide us information
                            about a case that you request us to create or update
                            on our Site
                        </Typography>
                    </li>
                </ul>
            </section>
            <section className={classes.section}>
                <Typography className={classes.title} variant="h4">
                    B. Use of Information Collected Via the Site
                </Typography>
                <Typography className={classes.text} variant="h5">
                    (1) Personally Identifiable Information
                </Typography>
                <Typography variant="body1" className={classes.text}>
                    We use your personally identifiable information that is
                    collected on the Site primarily for the following purposes:.
                </Typography>
                <ul className={classes.list}>
                    <li>
                        <Typography
                            variant="body1"
                            className={classes.listItem}
                        >
                            To process your orders, and to update you on the
                            status of your account and of cases you have
                            created;
                        </Typography>
                    </li>
                    <li>
                        <Typography
                            variant="body1"
                            className={classes.listItem}
                        >
                            To alert you to updated information and new products
                            and services from Orthosnap, or third parties, or to
                            forward promotional materials to you;
                        </Typography>
                    </li>
                    <li>
                        <Typography
                            variant="body1"
                            className={classes.listItem}
                        >
                            To allow you to share content and comments, if such
                            functionality becomes available;
                        </Typography>
                    </li>
                    <li>
                        <Typography
                            variant="body1"
                            className={classes.listItem}
                        >
                            To allow you to upload content, if such
                            functionality becomes available, and
                        </Typography>
                    </li>
                    <li>
                        <Typography
                            variant="body1"
                            className={classes.listItem}
                        >
                            To contact you in response to sign-up forms such as
                            “Contact Us” or other inquiry;
                        </Typography>
                    </li>
                    <li>
                        <Typography
                            variant="body1"
                            className={classes.listItem}
                        >
                            To continuously improve your experience and the
                            quality of the service provided by Orthosnap.
                        </Typography>
                    </li>
                </ul>
            </section>
            <section className={classes.section}>
                <Typography className={classes.text} variant="h5">
                    (2) Non-Personally Identifiable Information
                </Typography>
                <Typography variant="body1" className={classes.text}>
                    Non-personally identifiable information is used as described
                    above and in other ways as permitted by applicable laws,
                    including combining non-personally identifiable information
                    with personally identifiable information.
                </Typography>
            </section>
            <section className={classes.section}>
                <Typography className={classes.text} variant="h5">
                    (3) Case Information
                </Typography>
                <Typography variant="body1" className={classes.text}>
                    We use your Case Information that you authorize us to access
                    primarily for the following purposes:
                </Typography>
                <ul className={classes.list}>
                    <li>
                        <Typography
                            variant="body1"
                            className={classes.listItem}
                        >
                            To process Cases and their attached Orders in
                            delivery of the Orthosnap service
                        </Typography>
                    </li>
                </ul>
            </section>
            <section className={classes.section}>
                <Typography className={classes.title} variant="h4">
                    C. Sharing and Disclosure of Information
                </Typography>
                <Typography className={classes.text} variant="h5">
                    (1) Personally Identifiable Information
                </Typography>
                <Typography variant="body1" className={classes.text}>
                    We may share or disclose your personally identifiable
                    information in the following instances:
                </Typography>
                <Typography variant="body1" className={classes.text}>
                    (i) To fulfill a service. For example, if you place an
                    order, we may share the shipping address with a shipping
                    company in order to deliver the order;
                </Typography>
                <Typography variant="body1" className={classes.text}>
                    (ii) To third-party service providers, agents or independent
                    contractors who help us maintain our Site and provide other
                    administrative services to us. If you do not wish for our
                    unaffiliated third-party service providers to have access to
                    your information, please do not register or submit any
                    personally identifiable information to us.
                </Typography>
                <Typography variant="body1" className={classes.text}>
                    (iii) To comply with the law or in the good faith belief
                    that such action is necessary in order to conform to the
                    requirements of law or comply with legal process served on
                    us, protect and defend our rights or property, including the
                    rights and property of Orthosnap or act in urgent
                    circumstances to protect the personal safety of our other
                    users.
                </Typography>
                <Typography variant="body1" className={classes.text}>
                    (iv) To third parties as part of any corporate
                    reorganization process including, but not limited to,
                    mergers, acquisitions, and sales of all or substantially all
                    of our assets.
                </Typography>
                <Typography variant="body1" className={classes.text}>
                    (v) To protect against potential fraud, we may verify with
                    third parties the information collected from these Site. In
                    the course of such verification, we may receive personally
                    identifiable information about you from such services
                </Typography>
                <Typography variant="body1" className={classes.text}>
                    Except as described in this Privacy Policy or at the time we
                    request the information, we do not otherwise use, share or
                    otherwise disclose your personally identifiable information
                    to any third parties.
                </Typography>
            </section>
            <section className={classes.section}>
                <Typography className={classes.text} variant="h5">
                    (2) Non-Personally Identifiable Information
                </Typography>
                <Typography variant="body1" className={classes.text}>
                    We use non-personally identifiable information collected on
                    the Site in the manner disclosed above, in Section A (2). We
                    may share this non-personal information with third parties.
                </Typography>
            </section>
            <section className={classes.section}>
                <Typography className={classes.text} variant="h5">
                    (3) Case Information
                </Typography>
                <Typography variant="body1" className={classes.text}>
                    (i) To fulfill a service. For example, if you create a Case,
                    we may use part of the Case information in order to locate
                    and identify the case in discussions;
                </Typography>
                <Typography variant="body1" className={classes.text}>
                    (ii) To third-party service providers, agents or independent
                    contractors who help us maintain our Site and provide other
                    administrative services to us. If you do not wish for our
                    unaffiliated third-party service providers to have access to
                    your information, please do not register or submit any
                    personally identifiable information to us.
                </Typography>
                <Typography variant="body1" className={classes.text}>
                    (iii) To comply with the law or in the good faith belief
                    that such action is necessary in order to conform to the
                    requirements of law or comply with legal process served on
                    us, protect and defend our rights or property, including the
                    rights and property of Orthosnap or act in urgent
                    circumstances to protect the personal safety of our other
                    users.
                </Typography>
                <Typography variant="body1" className={classes.text}>
                    (iv) To third parties as part of any corporate
                    reorganization process including, but not limited to,
                    mergers, acquisitions, and sales of all or substantially all
                    of our assets.
                </Typography>
                <Typography variant="body1" className={classes.text}>
                    Except as described in this Privacy Policy or at the time we
                    request the information, we do not otherwise use, share or
                    otherwise disclose Case information to any third parties.
                </Typography>
            </section>
            <section className={classes.section}>
                <Typography className={classes.title} variant="h4">
                    D. Collection and Use of Information from Children Under the
                    Age of 13
                </Typography>
                <Typography className={classes.text} variant="body1">
                    Orthosnap does not knowingly collect or solicit Personal
                    Information from anyone under the age of 13 or knowingly
                    allow such persons to use the Site. If you are under 13
                    please do not attempt to register on the Site or send us any
                    Personal Information.
                </Typography>
            </section>
            <section className={classes.section}>
                <Typography className={classes.title} variant="h4">
                    E. International Transfer of Information
                </Typography>
                <Typography className={classes.text} variant="body1">
                    This Policy is intended to provide adequate and consistent
                    safeguards for the handling of personal information in
                    accordance with Directive 95/46/EC of the European
                    Parliament and of the Council of 24 October 1995 on the
                    protection of individuals with regard to the processing of
                    personal data and on the free movement of such data (“the
                    Directive”) and all the relevant transposing legislation of
                    the Directive in the European Union/European Economic Area,
                    the Swiss Federal Data Protection Act, as such laws may from
                    time to time be amended and valid during the application of
                    this Policy, the Privacy Shield, and any other privacy laws,
                    regulations and principles concerning the collection,
                    storage, use, transfer and other processing of personal data
                    transferred from the European Economic Area or Switzerland
                    to the United States including but not limited to the
                    Regulation (EU) 2016/679 of the European Parliament and of
                    the Council of 27 April 2016 on the protection of natural
                    persons with regard to the processing of personal data and
                    on the free movement of such data, and repealing Directive
                    95/46/EC (“the General Data Protection Regulation”) as of
                    its entry into force on 25 May 2018.
                </Typography>
            </section>
            <section className={classes.section}>
                <Typography className={classes.title} variant="h4">
                    F. Opt-Out
                </Typography>
                <Typography className={classes.text} variant="body1">
                    From time to time, we communicate with users who subscribe
                    to our services via email or text message. For example, we
                    may use your email address to confirm your request, to send
                    you notice of payments, to send you information about
                    changes to our products and services, and to send notices
                    and other disclosures as required by law. Generally, users
                    cannot opt-out of these communications, but they will be
                    primarily informational in nature rather than promotional.
                </Typography>
                <Typography className={classes.text} variant="body1">
                    However, we provide you the opportunity to exercise an
                    opt-out choice if you do not want to receive other types of
                    communication from us, such as emails or updates from us
                    regarding new services and products offered on the Site or
                    if you do not want us to share your personally identifiable
                    information with third parties. The opt-out choice may be
                    exercised by ticking or un-ticking the appropriate box if
                    such checkbox is available at the points where personally
                    identifiable information is collected or by contacting us.
                </Typography>
            </section>
            <section className={classes.section}>
                <Typography className={classes.title} variant="h4">
                    H. Third Party Web Site
                </Typography>
                <Typography className={classes.text} variant="body1">
                    This statement applies solely to information collected on
                    the Site. The Site may contain links to other web sites. We
                    are not responsible for the privacy practices or the content
                    of these other web sites.
                </Typography>
            </section>
            <section className={classes.section}>
                <Typography className={classes.title} variant="h4">
                    I. Security
                </Typography>
                <Typography className={classes.text} variant="body1">
                    No data transmissions over the Internet can be guaranteed to
                    be 100% secure. Consequently, we cannot ensure or warrant
                    the security of any information you transmit to us and you
                    understand that any information that you transfer to
                    Orthosnap is done at your own risk.
                </Typography>
                <Typography className={classes.text} variant="body1">
                    Once we receive your transmission, we make reasonable
                    efforts to ensure security on our systems.We adopt
                    appropriate data collection, storage and processing
                    practices and security measures to protect against
                    unauthorized access, alteration, disclosure or destruction
                    of your personal information, username, password,
                    transaction information and data stored on our Sites..
                    However, please note that this is not a guarantee that such
                    information may not be accessed, disclosed, altered or
                    destroyed by breach of such firewalls and secure server
                    software.
                </Typography>
                <Typography className={classes.text} variant="body1">
                    If we learn of a security systems breach we may attempt to
                    notify you electronically so that you can take appropriate
                    protective steps.
                </Typography>
            </section>
            <section className={classes.section}>
                <Typography className={classes.title} variant="h4">
                    J. Your rights & contacting Orthosnap
                </Typography>
                <Typography className={classes.text} variant="body1">
                    If you have any questions about this privacy policy or our
                    privacy practices, please contact us at
                    support@Orthosnap.com. All information you provide in any
                    written communication will also be covered by this policy.
                </Typography>
            </section>
            <section className={classes.section}>
                <Typography className={classes.title} variant="h4">
                    K. Your consent & updates to this policy
                </Typography>
                <Typography className={classes.text} variant="body1">
                    You acknowledge that this Privacy Policy is part of the
                    Terms & Conditions for your use of the Sites, and you agree
                    that using the Sites signifies your assent to Orthosnap’
                    Privacy Policy. Orthosnap reserves the right to change this
                    Privacy Policy at any time. If we decide to change our
                    Privacy Policy, we will post those changes on this page so
                    that you are always aware of what information we collect,
                    how we use it and under what circumstances we disclose it.
                    As we may make changes from time to time without notifying
                    you, we suggest that you periodically consult this Policy.
                    Your continued use of the Sites after the effective date of
                    any modification to the Policy will be deemed to be your
                    agreement to the changed terms.
                </Typography>
                <Typography className={classes.text} variant="body1">
                    If you demonstrate that the purpose for which the data is
                    being processed in no longer legal or appropriate, the data
                    will be deleted, unless the applicable law requires
                    otherwise.
                </Typography>
                <Typography className={classes.text} variant="body1">
                    Effective Date: 9/23/2020
                </Typography>
                <Typography className={classes.text} variant="body1">
                    Last Updated On: 9/23/2020
                </Typography>
            </section>
        </Container>
    );
};
